import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/src/providers/QueryProvider.tsx");
